import React from "react";
import { FaLinkedinIn, FaInstagram} from "react-icons/fa";

export default function Footer() {

  const socialLinks = [
  { Icon: FaLinkedinIn, url: "https://www.linkedin.com/company/digital-ledger-media/", hoverColor: "#0A66C2" },
  { Icon: FaInstagram, url: "https://www.instagram.com/digitalledgermedia/?utm_source=ig_web_button_share_sheet", hoverColor: "#E4405F" },
];
  return (
    <footer
      style={{
        width: "100%",
        backgroundColor: "#000",
        borderTop: "1px solid rgba(255,255,255,0.1)",
        color: "#aaa",
        padding: "30px 40px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      {/* Top Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        {/* Left Logo & Info */}
        <div style={{ display: "flex", alignItems: "center", gap: "50px" }}>
          <img
            src="/demoimage.png"
            alt="Footer Logo"
            style={{ width: "100px", height: "100px" }}
          />
          <div style={{ lineHeight: "1.6" }}>
            <h3 style={{ color: "#fff", marginBottom: "5px" }}>
              Digital Ledger Media
            </h3>
            <p style={{ margin: 0 }}>📍 Delhi, India</p>
            <p style={{ margin: 0 }}>📞 +91 73020 05174 </p>
            <p style={{ margin: 0 }}>✉️ collab@digitalledgermedia.com</p>
          </div>
        </div>

        {/* Social Icons moved to Top Right */}
        <div style={{ display: "flex", gap: "15px", marginTop: "15px" }}>
          {socialLinks.map(({ Icon, url, hoverColor }, i) => (
          <a
            key={i}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: "rgb(255, 140, 0)",
              padding: "10px",
              borderRadius: "8px",
              color: "#000",
              fontSize: "15px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = hoverColor;
              e.currentTarget.style.color = "#fff"; // icon visible rahe
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgb(255, 140, 0)";
              e.currentTarget.style.color = "#000";
            }}
          >
            <Icon />
          </a>
        ))}
        </div>
      </div>

      {/* Divider Line */}
      <div
        style={{
          height: "1px",
          background: "rgba(255,255,255,0.1)",
          margin: "10px 0",
        }}
      ></div>

      {/* Bottom Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Left Copyright */}
        <div style={{ color: "#888", fontSize: "13px" }}>
          © 2025 Digital Ledger Media. All rights reserved.
        </div>

        {/* Privacy & Terms moved to Right Bottom */}
        <div
          style={{
            display: "flex",
            gap: "25px",
            fontSize: "14px",
            marginTop: "10px",
          }}
        >
          <a href="privacy" style={{ color: "#aaa", textDecoration: "none" }}>
            Privacy Policy
          </a>
          <a
            href="termconditions"
            style={{ color: "#aaa", textDecoration: "none" }}
          >
            Terms & Conditions
          </a>
        </div>
      </div>
    </footer>
  );
}
